module.exports = __webpack_public_path__ + "img/04.dd9b08d8.png";